export const hide = {
  mounted: function (el, binding, vnode) {
    hideEl(el, binding, vnode);
  },
  updated: function (el, binding, vnode) {
    hideEl(el, binding, vnode);
  },
};

function hideEl(el, binding, vnode) {
  const duration = binding.value.duration ? binding.value.duration : 300;
  const transition = binding.value.transition ? binding.value.transition : "fade";
  el.classList.add("hide-element");
  el.style.setProperty("--element-max-height", el.offsetHeight + "px");
  el.style.setProperty("--element-animation-duration", duration + "ms");
  el.style.setProperty("--element-transition-type", "hide-transition-" + transition);
  const hide = binding.value.hide;
  if (hide) {
    el.classList.add("-isHiding");
    setTimeout(() => {
      const evt = new CustomEvent("hideComplete");
      vnode.el.dispatchEvent(evt);
    }, duration);
  }
}
